import { Card } from '@blueprintjs/core';
import React from 'react';
import { BlackPointCounters, BlackPointCountersProps } from './BlackPointCounters';
import { DutyCounters, DutyCountersProps } from './DutyCounters';

interface CalendarCountersProps extends BlackPointCountersProps, DutyCountersProps {}

export const CalendarCounters = ({
  blackPointHolidayCount,
  blackPointHolidayMax,
  blackPointEconomicCount,
  blackPointEconomicMax,
  annualFreeBankHolidayMax,
  annualFreeWeekendMax,
  blackPointOnBankHolidayCount,
  blackPointOnWeekendCount,
  showEconomicCounters,
  semester1DutyCounters,
  semester2DutyCounters,
}: CalendarCountersProps) => {
  return (
    <>
      <Card
        style={{
          margin: 4,
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          flex: 1,
        }}
      >
        <BlackPointCounters
          blackPointHolidayCount={blackPointHolidayCount}
          blackPointHolidayMax={blackPointHolidayMax}
          blackPointEconomicMax={blackPointEconomicMax}
          annualFreeBankHolidayMax={annualFreeBankHolidayMax}
          blackPointOnBankHolidayCount={blackPointOnBankHolidayCount}
          annualFreeWeekendMax={annualFreeWeekendMax}
          blackPointOnWeekendCount={blackPointOnWeekendCount}
          blackPointEconomicCount={blackPointEconomicCount}
          showEconomicCounters={showEconomicCounters}
        />
      </Card>
      <DutyCounters semester1DutyCounters={semester1DutyCounters} semester2DutyCounters={semester2DutyCounters} />
    </>
  );
};
